import api from "services/api";

// Get all leaves
export const getMyLeaves = async (params = {}) => {
  return api.get("/v1/api/admin/leaves", { params });
};

// approve or reject (update)
export const updateLeaveAction = async (leaveId, actionData) => {
  return api.put(`/v1/api/admin/leave-action/${leaveId}`, actionData);
};

// Get yearly leave report
export const getYearlyLeaveReport = async (params = {}) => {
  return api.get("/v1/api/admin/yearly-leave-report", { params });
};

// Adjust leave balance (credit/debit)
export const adjustLeaveBalance = async (data) => {
  return api.post("/v1/api/admin/leave-adjust", data);
};
